import React, { useEffect, useRef, useLayoutEffect } from 'react';

export default ({open, onClose, children, openFrom, className, headerBordered}) => {

    const drawerRef = useRef(null);

    useLayoutEffect(() => {
        drawerRef.current.addEventListener('dialog:after-hide', onClose);
        return () => {
            drawerRef.current.removeEventListener('dialog:after-hide', onClose);
        }
    }, [drawerRef.current]);

    useEffect(() => {
        if (open && !drawerRef.current.open) {
            drawerRef.current.show();
        }else if (!open && drawerRef.current.open){
            drawerRef.current.hide();
        }
    }, [open]);

    return (
        <x-drawer class={`drawer ${className || ''}`} ref={drawerRef} open-from={openFrom} header-bordered={headerBordered}>
            {children}
        </x-drawer>
    );
}